import { render } from "./activity.vue?vue&type=template&id=634f04e7"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"
script.render = render

export default script